import { FunctionComponent } from "react";
import PricingImg from '../../../../assets/pricing-header.png';
import MobileAuthButtons from "../../landing/MobileAuthButtons";

interface PriceHeaderProps {
  title?: string;
  height?: string;
}

const PriceHeader: FunctionComponent<PriceHeaderProps> = ({ 
  title = "Products", 
  height = "250px" 
}) => {
  return (
    <div>
      <MobileAuthSection />
      <HeroSection title={title} height={height} />
    </div>
  );
};

const MobileAuthSection: FunctionComponent = () => (
  <MobileAuthButtons />
);

const HeroSection: FunctionComponent<{ title: string; height: string }> = ({ title, height }) => (
  <div className="w-full relative" style={{ height }}>
    <BackgroundImage height={height} />
    <BackgroundOverlay height={height} />
    <HeroTitle title={title} />
  </div>
);

const BackgroundImage: FunctionComponent<{ height: string }> = ({ height }) => (
  <img 
    src={PricingImg} 
    alt="Pricing header background"
    className="w-full absolute left-0 top-0 z-30 object-cover"
    style={{ height }}
  />
);

const BackgroundOverlay: FunctionComponent<{ height: string }> = ({ height }) => (
  <div 
    className="w-full bg-black absolute left-0 top-0 z-40 opacity-50"
    style={{ height }}
  />
);

const HeroTitle: FunctionComponent<{ title: string }> = ({ title }) => (
  <h1 className="text-white font-medium text-6xl p-12 relative z-50 font-sans tracking-wider">
    {title}
  </h1>
);


export default PriceHeader;


